export default __webpack_public_path__ + "static/2-7-0-0-207ee46e3b3ff858b28e2abfe03e1f6f.jpg";